import { useEffect } from 'react';
import { useRouter } from 'expo-router';
import { VERTICAL_ESCOLAR_VISIBLE } from '../constants/featureFlags';

/**
 * Saca al usuario de las pantallas del vertical escolar mientras esté oculto.
 *
 * Esconder las tarjetas de la portada no basta: las rutas de expo-router siguen
 * existiendo y se alcanzan escribiendo la URL, desde un enlace viejo o desde una
 * notificación guardada. Un revisor de Google Play que llegue por ahí aterriza
 * justo en el módulo que sabemos roto — la lista de alumnos vacía y los botones
 * que no responden.
 *
 * Devuelve `true` cuando la pantalla NO debe pintarse. Úsalo justo encima del
 * `return` de la pantalla:
 *
 *     const escolarOculto = useGuardiaEscolar();
 *     if (escolarOculto) return null;
 *
 * Si el vertical vuelve a activarse (`VERTICAL_ESCOLAR_VISIBLE = true`), el hook
 * devuelve siempre `false` y no hay que quitarlo de ningún sitio.
 */
export function useGuardiaEscolar(): boolean {
  const router = useRouter();

  useEffect(() => {
    if (VERTICAL_ESCOLAR_VISIBLE) return;
    // `replace` y no `push`: no debe quedar en el historial una pantalla a la
    // que el usuario no puede volver.
    router.replace('/');
  }, [router]);

  return !VERTICAL_ESCOLAR_VISIBLE;
}
